export default {
  setIsSyncedSuccessfully(state, success) {
    state.isSyncedSuccessfully = success
  },
}
